<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="手机号：">
            <el-input
              v-model="query.userPho"
              placeholder="请输入手机号"
              clearable
              size="small"
            />
          </el-form-item>
          <el-form-item label="身份：">
            <el-select
              v-model="query.levelId"
              placeholder="全部"
              clearable
              size="small"
            >
              <el-option
                v-for="(item, index) in technicalServiceLevel"
                :key="index"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标题：">
            <el-input
              v-model="query.title"
              placeholder="请输入标题"
              clearable
              size="small"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini"
              >搜索</el-button
            >
            <el-button type="info" @click="handleFilter" plain size="mini"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick">
          <el-tab-pane label="全部" name="all"></el-tab-pane>
          <el-tab-pane label="编辑过文章" name="edited"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <el-button
            type="primary"
            size="mini"
            @click="handleExport"
            icon="el-icon-download"
            >导出</el-button
          >
        </div>
      </div>
      <el-table
        v-loading="listLoading"
        :data="list"
        @selection-change="selectionChange"
        @sort-change="sortChange"
      >
        <el-table-column type="selection" width="50" />
        <el-table-column label="分享人" prop="shareUserName" align="center" />
        <el-table-column label="身份" prop="shareUserIdentity" align="center" />
        <el-table-column
          label="手机号"
          prop="shareUserPho"
          align="center"
          min-width="120"
        />
        <el-table-column
          label="标题"
          prop="title"
          align="center"
          min-width="200"
        />
        <el-table-column
          label="分类"
          prop="shareShowVO.classificationName"
          align="center"
        />
        <el-table-column label="发布者" prop="createdBy" align="center" />
        <el-table-column
          label="分享时间"
          prop="createdTime"
          sortable="custom"
          align="center"
          width="180"
        />
        <el-table-column label="操作" align="center" width="120" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleShowContent(row)"
              >查看内容</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :pageNo.sync="query.pageNo"
        :pageSize.sync="query.pageSize"
        @pagination="doQueryList"
      />
    </el-card>
  </div>
</template>

<script>
import templateMaterialsShareAnalyzeApi from "@/api/marketing/templateMaterialsShareAnalyze";
import Pagination from "@/components/Pagination";
import technicalServiceLevelApi from "@/api/sys/technicalServiceLevel";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      activeTab: "all",
      query: {
        pageNo: 1,
        pageSize: 10,
        orderNoSortSign: 1
      },
      selectItems: [],
      technicalServiceLevel: []
    };
  },
  created() {
    this.doQueryList({ pageNo: 1 });
    technicalServiceLevelApi.findOptions().then(({ data }) => {
      this.technicalServiceLevel = data;
    });
  },
  methods: {
    // 标题字段为后端存储的 JSON 字符串，这里解析并拼装展示
    formatTitle(title) {
      if (!title) return "--";
      try {
        const list = typeof title === "string" ? JSON.parse(title) : title;
        if (!Array.isArray(list)) return "--";
        const names = list
          .map(it => it && (it.titleName || it.name || ""))
          .filter(Boolean);
        return names.length ? names.join(" / ") : "--";
      } catch (e) {
        return title || "--";
      }
    },
    handleShow(row, type) {
      this.$emit("handleShow", row, type);
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10
      };
      this.activeTab = "all";
      this.doQueryList({ pageNo: 1, pageSize: 10 });
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val;
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        createdTime: "createdTimeSortSign"
      };
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k];
        if (k !== prop) {
          this.query[sortKey] = null;
        } else {
          if (order === "ascending") {
            this.query[sortKey] = 1;
          } else {
            this.query[sortKey] = -1;
          }
        }
      }
      this.doQueryList({});
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 });
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo;
      }
      if (pageSize) {
        this.query.pageSize = pageSize;
      }

      this.listLoading = true;
      return templateMaterialsShareAnalyzeApi
        .fetchList(this.query)
        .then(data => {
          // 处理返回的数据，如果数据在 templateMaterialsShareAnalyzePO 中，需要提取
          const list = (data.data && data.data.list) || [];
          this.list = list.map(item => {
            // 如果数据在 templateMaterialsShareAnalyzePO 中，则展开它
            if (item.templateMaterialsShareAnalyzePO) {
              const po = item.templateMaterialsShareAnalyzePO;
              return {
                ...item,
                ...po,
                // 确保 shareShowVO 也被正确传递
                shareShowVO: item.shareShowVO || po.shareShowVO
              };
            }
            return item;
          });
          this.total = (data.data && data.data.total) || 0;
        })
        .catch(err => {
          console.error("获取列表数据失败:", err);
          this.list = [];
          this.total = 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 标签页切换
     */
    handleTabClick(tab) {
      if (tab.name === "edited") {
        this.query.isEdited = 1;
      } else {
        this.query.isEdited = undefined;
      }
      this.doQueryList({ pageNo: 1 });
    },
    /**
     * 导出功能
     */
    handleExport() {
      const params = new URLSearchParams();
      params.append('code', 'ExportMaterialsShareAnalyze');
      if (this.query.title) {
        params.append('title', this.query.title);
      }
      if (this.query.userPho) {
        params.append('userPho', this.query.userPho);
      }
      this.$router.push(`/export/list?${params.toString()}`)
    },
    /**
     * 查看内容
     */
    handleShowContent(row) {
      // 传递完整的数据，包括分享人信息
      this.$emit("handleShow", row, 2);
    }
  }
};
</script>
